import React from 'react';
import { COLORS } from '../../../../utils/constants';
import { Edit2, Trash2 } from 'lucide-react';
import { getRoleColor, getRoleLabel } from './TeamUIComponents';

const TeamList = ({ team, loading, user, isSuperAdmin, onEdit, onDelete }) => (
  <div style={{
    backgroundColor: COLORS.card,
    borderRadius: '12px',
    border: `1px solid ${COLORS.border}`,
    overflow: 'hidden'
  }}>
    <div style={{
      display: 'grid',
      gridTemplateColumns: '2fr 1fr 1fr 1fr 120px',
      padding: '12px 20px',
      backgroundColor: COLORS.background,
      borderBottom: `1px solid ${COLORS.border}`,
      gap: '12px'
    }}>
      <span style={{ color: COLORS.textSecondary, fontSize: '12px', fontWeight: '600' }}>СОТРУДНИК</span>
      <span style={{ color: COLORS.textSecondary, fontSize: '12px', fontWeight: '600' }}>РОЛЬ</span>
      <span style={{ color: COLORS.textSecondary, fontSize: '12px', fontWeight: '600' }}>ПРИВЯЗКА</span>
      <span style={{ color: COLORS.textSecondary, fontSize: '12px', fontWeight: '600' }}>КЛИЕНТЫ</span>
      <span style={{ color: COLORS.textSecondary, fontSize: '12px', fontWeight: '600' }}></span>
    </div>
    <div style={{ maxHeight: 'calc(100vh - 400px)', overflowY: 'auto' }}>
      {loading ? (
        <div style={{ padding: '40px', textAlign: 'center', color: COLORS.textSecondary }}>Загрузка...</div>
      ) : team.length === 0 ? (
        <div style={{ padding: '40px', textAlign: 'center', color: COLORS.textSecondary }}>Нет сотрудников</div>
      ) : (
        team.map((m) => (
          <div key={m.id} style={{
            display: 'grid',
            gridTemplateColumns: '2fr 1fr 1fr 1fr 120px',
            padding: '12px 20px',
            borderBottom: `1px solid ${COLORS.border}20`,
            gap: '12px',
            alignItems: 'center'
          }}>
            <div style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
              <div style={{
                width: '36px',
                height: '36px',
                borderRadius: '50%',
                backgroundColor: `${getRoleColor(m.role)}20`,
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                color: getRoleColor(m.role),
                fontWeight: '600',
                fontSize: '14px'
              }}>
                {m.name?.charAt(0).toUpperCase() || m.email?.charAt(0).toUpperCase()}
              </div>
              <div>
                <div style={{ color: COLORS.text, fontSize: '14px', fontWeight: '500' }}>{m.name || 'Без имени'}</div>
                <div style={{ color: COLORS.textSecondary, fontSize: '11px' }}>{m.email}</div>
              </div>
            </div>
            <span style={{
              padding: '4px 10px',
              borderRadius: '20px',
              backgroundColor: `${getRoleColor(m.role)}20`,
              color: getRoleColor(m.role),
              fontSize: '11px',
              fontWeight: '600',
              width: 'fit-content'
            }}>
              {getRoleLabel(m.role)}
            </span>
            <div style={{ color: COLORS.textSecondary, fontSize: '12px' }}>
              {m.parent_admin ? (m.parent_admin.name || m.parent_admin.email) : '-'}
            </div>
            <div style={{ color: COLORS.text, fontSize: '14px', fontWeight: '600' }}>
              {m.client_count || 0}
            </div>
            {isSuperAdmin && (
              <div style={{ display: 'flex', gap: '6px' }}>
                <button
                  onClick={() => onEdit(m)}
                  style={{
                    padding: '6px',
                    backgroundColor: COLORS.background,
                    border: `1px solid ${COLORS.border}`,
                    borderRadius: '6px',
                    color: COLORS.textSecondary,
                    cursor: 'pointer'
                  }}
                >
                  <Edit2 size={14} />
                </button>
                <button
                  onClick={() => onDelete(m)}
                  style={{
                    padding: '6px',
                    backgroundColor: `${COLORS.danger}15`,
                    border: `1px solid ${COLORS.danger}40`,
                    borderRadius: '6px',
                    color: COLORS.danger,
                    cursor: 'pointer'
                  }}
                >
                  <Trash2 size={14} />
                </button>
              </div>
            )}
          </div>
        ))
      )}
    </div>
  </div>
);

export default TeamList;
